import SectionHomeColumns from './SectionHomeColumns';
export default SectionHomeColumns;
